// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__jZIpt","Header__pic":"Header_Header__pic__3sKr3","Header__content":"Header_Header__content__V3PlG"};